<template>
  <div class="container mt-2">
    <div class="row">
      <div class="col-sm-12 col-md-6 offset-md-3">
        <p class="text-center">
          <img
            v-if="drawingLoaded"
            :src="'data:image/png;base64,' + drawing.image"
            alt=""
            style="width: 100%"
          />
        </p>
        <form
        v-if="drawingLoaded"
          class="form-horizontal save-link-form text-center"
          @submit.prevent="onSubmit(email, name)"
        >
        <label>Pour recevoir le lien de votre Vidéo</label>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="form-group mb-3">
            <input
              autofocus
              v-model="email"
              name="email"
              class="form-control"
              :class="{ 'is-invalid': submitted && !email }"
              type="email"
              required
              placeholder="Entrez votre adresse email"
            />
            <div v-show="submitted && !name" class="invalid-feedback">
              L'email est obligatoire
            </div>
          </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="form-group mb-3">
            <input
              v-model="name"
              name="name"
              class="form-control"
              type="text"
              placeholder="Prénom de l’enfant (optionnel)"
            />
          </div>
          </div>
      
        </div>
        <div align="left" class="terms-and-conditions">
          <input v-model="termCheckboxChecked" type="checkbox" value="agree" /> J'ai pris connaissance des conditions ci-après et je les accepte.L'email que je vais recevoir peut contenir une offre promotionnelle du partenaire de cette opération mais votre adresse email ne lui sera pas transmise. Vous êtes néanmoins susceptible de recevoir prochainement des offres promotionnelles de Wakatoon, dont vous pourrez vous désinscrire à tout moment sur simple demande.
        </div>
        <div align="left" class="terms-and-conditions" >
          <ul class="list-unstyled">
            <li><a href="https://www.wakatoon.com/fr/mentions-legales/" target="_blank">Conditions Générales d'Utilisation</a></li>
            <li><a href="https://www.wakatoon.com/fr/politique-de-confidentialit%C3%A9/" target="_blank">Politique de confidentialité</a></li>
          </ul>
        </div>
            <button type="submit" :disabled="!termCheckboxChecked" class="btn btn-dark">Envoyer</button>
        </form>
      </div>
    </div>
  </div>
</template>

.disable_section {
  pointer-events: none;
  opacity: 0.4;
}

<script>
import { mapGetters } from "vuex";
import { SEND_EMAIL_ACTION, GET_DRAWING_ACTION } from "../../store/actions.type";


export default {
  name: "SaveLinkForm",
  data() {
    return {
      email: "",
      name: "",
      submitted: false,
      drawingLoaded: false,
      termCheckboxChecked: false
    };
  },
  methods: {
    onSubmit(email, name) {
       let loader = this.$loading.show({
        container: null,
        canCancel: true
      });
      let formData = new FormData();
      formData.append("photoId", this.$route.query.photoId);
      formData.append("userEmail", email);
      formData.append("artworkType", "coloring");

      if(name.trim() != '') {
        formData.append("userFirstName", name);
      }

      this.$store.dispatch(SEND_EMAIL_ACTION, formData).then(() => {
        loader.hide();
        this.email = "";
        
        /* this.$alert(
          "Nous vous avons envoyé le lien de votre vidéo par mail",
          "Succès",
          "success"
        ); */
        this.$router.push({ path: "/link/request/sent", query: {photoId: this.$route.query.photoId,operation: this.$route.query.operation,storyId: this.$route.query.storyId} });
      });
    },
    getDrawing() {
      let loader = this.$loading.show({
        container: null,
        canCancel: true
      });
      let photoId = this.$route.query.photoId;
      this.$store.dispatch(GET_DRAWING_ACTION, { photoId })
      .then(() => {
        loader.hide();
        this.drawingLoaded = true;
      }).catch(() => {
        this.drawingLoaded = false;
        loader.hide();
        this.$alert(
          "Photo introuvable. Veuillez vérifier le lien de votre photo.",
          "Erreur",
          "error"
        );
      });
    },
  },
  computed: {
    ...mapGetters(["drawing"]),
  },
  mounted() {
    this.getDrawing();
  },
};
</script>